<template>
    <results-student-preparate v-if="isLanding"
            :carrera="carrera"
            :puntaje="puntaje"
            :total="total"
            :resultados="resultados"
            :aprobado="aprobado"
    />
    <results-student v-else
            :carrera="carrera"
            :puntaje="puntaje"
            :total="total"
            :resultados="resultados"
            :aprobado="aprobado"
    />
    
</template>

<script>
    import ResultsStudent from '@/components/Global/ResultsStudent'
    import ResultsStudentPreparate from '@/components/Global/ResultsStudentPreparate'

    export default {
        name: 'Resultados',
        components: {
            ResultsStudent,
            ResultsStudentPreparate
        },
        data: () => ({
            puntaje: '',
            aprobado: '',
            total: '',
            resultados: [],
            carrera: '',
            key: localStorage.getItem('idkey'),
            isLanding: localStorage.getItem('isLanding')
        }),
        created() {
            this.$store.dispatch('setModulo', 'TUS RESULTADOS')
            this.getResultado()
            let userdata = JSON.parse(localStorage.getItem('userdata'))
            this.carrera = userdata.carrera
        }, 
        methods: {
            getResultado() {
                let data = {
                    key: localStorage.getItem('idkey'),
                    id: localStorage.getItem('id_estudiante')
                };
                this.$store.dispatch('getResultado', data)
                    .then((response) => {
                        this.resultados = response.data.resultados
                        localStorage.setItem('id_simulacro', this.resultados[0].id_simulacro)
                        this.puntaje = response.data.puntaje_obtenido
                        this.total = response.data.total[0]
                        this.aprobado = response.data.aprobado
                    })
                    .catch((error) => {
                        console.log(error.message)
                    })
            }
        }
    }
</script>
<style scoped>
</style>